import Const from 'const';

interface LineupPlayerMapDataInterface {
    lineups: object;
    players: object;
}

const LineupPlayerMapData = {
    lineups: {},
    players: {},
};

function mergeKeysOfObjects(objects: object[] | object): any[] {
    let keys: any[] = [];
    Object.values(objects).map((object) => {
        keys = [...keys, ...Object.keys(object)];
    });

    return keys;
}

function filterObjectByKeys(object: object, keys: any[] = []): object {
    const filteredObject: object = {};
    Object.keys(object).map((key) => {
        if (inArray(key, keys)) {
            filteredObject[key] = object[key];
        }
    });

    return filteredObject;
}

class LineupPlayerMap {
    constructor(public readonly data: LineupPlayerMapDataInterface = LineupPlayerMapData) {}
    hasMap(): boolean {
        return !isEmpty(this.data.lineups);
    }
    getLineupsByPlayerId(playerId: number): object | null {
        return this.data.players[playerId] || null;
    }
    getLineupIdsByCheckedPlayers(checkedPlayers: object): string[] {
        if (!this.hasMap()) {
            return [];
        }

        let lineupIds: string[] = [];
        Object.keys(checkedPlayers).map((playerId) => {
            if (isEmpty(checkedPlayers[playerId]) || !(playerId in this.data.players)) {
                return;
            }

            const players = filterObjectByKeys(this.data.players[playerId], Object.keys(checkedPlayers[playerId]));

            const playerLineupIds: string[] = mergeKeysOfObjects(players);

            if (isEmpty(lineupIds)) {
                lineupIds = [...playerLineupIds];
                return;
            }

            lineupIds = arrayDuplicates(lineupIds, playerLineupIds);
        });

        return arrayUnique(lineupIds);
    }
    getPlayerIdsByLineupIds(lineupIds: string[]): string[] {
        if (!this.hasMap()) {
            return [];
        }

        let playerIds: string[] = [];
        lineupIds.map((lineupId) => {
            if (!this.data.lineups.hasOwnProperty(lineupId)) {
                return;
            }

            playerIds = [...playerIds, ...Object.keys(this.data.lineups[lineupId]).map(String)];
        });

        return arrayUnique(playerIds);
    }
}

const lineupPlayerMap = new LineupPlayerMap();

export default function (state = lineupPlayerMap, action) {
    switch (action.type) {
        case Const.SET_LINEUP_PLAYER_MAP:
            return new LineupPlayerMap(action.data);

        case Const.UNSET_LINEUPS:
        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return new LineupPlayerMap();

        default:
            return state;
    }
}
